'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const ShiftInfoContainer = styled.button<{ $hasInfo?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => (props.$hasInfo ? 'column' : 'row')};
  text-align: left;
  justify-content: space-between;
  border-radius: ${Spacers.XS}rem;
  border: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  padding: ${Spacers.BASE}rem;
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  cursor: ${(props) => (props.as === 'button' ? 'pointer' : 'default')};
  gap: ${Spacers.LG}rem;
`;

export const InfoItem = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const TimeInfoItem = styled.div`
  display: flex;
  gap: ${Spacers.BASE}rem;
`;

export const SchoolNameText = styled.p`
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  line-height: ${(props) => props.theme.typography.title.lineHeight};
`;
